var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$root.ready && _vm.lang
    ? _c(
        "div",
        { staticClass: "user-menu" },
        [
          _c("div", { staticClass: "user-container container" }, [
            _c("ul", { staticClass: "row" }, [
              _c(
                "li",
                {
                  staticClass: "col",
                  on: {
                    click: function($event) {
                      return _vm.onLinkClick("saved_searches")
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      alt: "searches",
                      src: "/img/icons/" + _vm.$root.network + "/searches.svg",
                      width: "31",
                      height: "22"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.lang.user_menu.labels.saved_searches) +
                        "\n                "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "col",
                  on: {
                    click: function($event) {
                      return _vm.onLinkClick("saved_estates")
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      alt: "favorites",
                      src: "/img/icons/" + _vm.$root.network + "/favorites.svg",
                      width: "24",
                      height: "22"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.lang.user_menu.labels.saved_estates) +
                        "\n                "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "col ico-hidden",
                  on: {
                    click: function($event) {
                      return _vm.onLinkClick("hidden_estates")
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      alt: "hidden",
                      src: "/img/icons/" + _vm.$root.network + "/hidden.svg",
                      width: "25",
                      height: "22"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.lang.user_menu.labels.hidden_estates) +
                        "\n                "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "col",
                  on: {
                    click: function($event) {
                      return _vm.onLinkClick(
                        _vm.$root.user_hash ? "profile" : "dashboard"
                      )
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      alt: "profile",
                      src: "/img/icons/" + _vm.$root.network + "/profile.svg",
                      width: "22",
                      height: "22"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.profileLabel) +
                        "\n                "
                    )
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("modal", {
            ref: "login",
            attrs: {
              name: "login",
              "extra-class": "bottom-modal login-modal animated fadeInUpBig",
              "auto-open": _vm.autoOpenLoginModal
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function(props) {
                    return [
                      _vm.config_footer.login_type == "register"
                        ? _c("login-form-register", {
                            attrs: {
                              target: _vm.section,
                              triggers_an_action: props.data
                                ? props.data.action
                                : null,
                              login_social: _vm.config_footer.login_social
                            }
                          })
                        : _c("login-form", {
                            attrs: {
                              target: _vm.section,
                              triggers_an_action: props.data
                                ? props.data.action
                                : null,
                              login_social: _vm.config_footer.login_social
                            }
                          })
                    ]
                  }
                }
              ],
              null,
              false,
              909224564
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }